<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="bold section">{{ title }}</div>
    </div>

    <bookmark-button :label="title" />

    <div class="ui divider"></div>

    <div class="ui grid">      
      <div class="eleven wide computer sixteen wide tablet sixteen wide mobile column">
        <button class="ui blue button" @click="$refs.formModal.create()">
          <i class="plus icon"></i> Nova Espécie
        </button>
      </div>
      <div class="five wide computer sixteen wide tablet sixteen wide mobile column">
        <div class="ui basic right aligned segment no-padding no-margin">
          <div class="ui form">
            <div class="field">
              <search-input id="species-search-input" ref="searchInput" @onSearch="search" />
            </div>
          </div>    
        </div> 
      </div>
    </div>

    <data-table id="species-dtbl" ref="dtbl" :service="service" :attributes="attributes" :fields="fields" @onRowClick="onUpdate" />

    <form-modal ref="formModal" @onSave="refresh" @onRemove="refresh" />

  </div>

</template>

<script>
  
  import SpeciesService from "@/services/species-service"
  import FormModal from "./form-modal"
  import { gridPage, onlySimavet } from "@/mixins"

  export default {    

    name: "SpeciesPage",

    mixins: [gridPage, onlySimavet],

    data() {
      return {        
        title: "Espécies",
        service: new SpeciesService(),
        attributes: ["id", "name"],
        fields: [          
          { prop: "name", label: "Nome da Espécie" },           
        ],
      }
    },

    components: {
      FormModal,
    },

    methods: {

      onUpdate(data) {
        this.$refs.formModal.update(data.row)
      }
    },
  }

</script>
